export default __webpack_public_path__ + "static/media/team.9b3e510f.png";